import React from 'react'
import { isAfter, format, addMinutes, addDays, subDays, parseISO, set } from 'date-fns'
import { jsonToState } from 'atpjs/helpers/json'
import CancelablePromise from 'atpjs/cancelable_promise'
import { DateInput, TimeInput } from 'atpjs/components/form/input'
import NumberInput from 'atpjs/components/form/number'
import Checkbox from 'atpjs/components/form/checkbox'

const formatDate = (date) => {
  return format(date, 'yyyy-MM-dd')
}

const setTime = (date, time) => {
  const [hours, minutes] = time.split(':').map((number) => Number(number))
  return set(date, { hours, minutes })
}

export const slotGenerator = (props) => {
  return (requestDate) => {
    let {
      firstDate = null,
      days = 5,
      branchCount = 1,
      startTime = '07:00',
      endTime = '19:00',
      slotTime = 60,
      every = 30,
      previousStartDate = false,
      nextStartDate = true,
      availableChance = 0.5,
      error = false
    } = props

    if (error) return CancelablePromise.reject()
    if (typeof requestDate === 'string') requestDate = parseISO(requestDate)
    if (firstDate == null) firstDate = requestDate
    if (typeof firstDate === 'string') firstDate = parseISO(firstDate)
    const lastDate = addDays(firstDate, days)
    const branches = []

    for (let x = 0; x < branchCount; x++) {
      const branch = {
        id: 11 + x,
        name: `Test Branch ${x}`,
        holidays: [],
        slots: {}
      }
      for (let y = 0; y < days; y++) {
        const currentDate = addDays(firstDate, y)
        branch.slots[formatDate(currentDate)] = []
        const currentStart = setTime(currentDate, startTime)
        const currentEnd = setTime(currentDate, endTime)
        let slotIndex = 0
        while (!isAfter(addMinutes(currentStart, slotIndex * every + slotTime), currentEnd)) {
          const slotStart = addMinutes(currentStart, slotIndex * every)
          const slotEnd = addMinutes(currentStart, slotIndex * every + slotTime)
          const slot = {
            start: slotStart.toISOString(),
            end: slotEnd.toISOString(),
            available: Math.random() < availableChance
          }
          branch.slots[formatDate(currentDate)].push(slot)
          slotIndex++
        }
      }
      branches.push(branch)
    }

    const result = {
      date_range: { start: formatDate(firstDate), end: formatDate(lastDate) },
      time_range: { start: startTime, end: endTime },
      previous_start_date: previousStartDate ? formatDate(subDays(firstDate, days)) : null,
      next_start_date: nextStartDate ? formatDate(addDays(lastDate, 1)) : null,
      branches
    }
    // eslint-disable-next-line
    console.info(JSON.stringify(result))
    return CancelablePromise.resolve(jsonToState({})(result))
  }
}

export const defaultDebugData = {
  firstDate: null,
  days: 5,
  branchCount: 1,
  startTime: '07:00',
  endTime: '19:00',
  slotTime: 60,
  every: 30,
  previousStartDate: false,
  nextStartDate: true,
  availableChance: 0.5,
  error: false
}

const SlotGenerator = ({ data, setData, reloadCurrentDate }) => {
  const inputProps = (key) => {
    return {
      value: data[key],
      onChange: (value) => {
        setData(
          Object.freeze({
            ...data,
            [key]: value
          })
        )
        reloadCurrentDate()
      },
      label: key
    }
  }
  return (
    <div style={{ backgroundColor: '#c5c5c5', border: '1px red dotted' }}>
      <DateInput {...inputProps('firstDate')} />
      <NumberInput {...inputProps('days')} />
      <NumberInput {...inputProps('branchCount')} />
      <TimeInput {...inputProps('startTime')} />
      <TimeInput {...inputProps('endTime')} />

      <NumberInput {...inputProps('slotTime')} />
      <NumberInput {...inputProps('every')} />
      <Checkbox
        values={[{ label: 'previous_start_date', value: true }]}
        {...inputProps('previousStartDate')}
        label=""
      />
      <Checkbox values={[{ label: 'next_start_date', value: true }]} {...inputProps('nextStartDate')} label="" />
      <Checkbox values={[{ label: 'error', value: true }]} {...inputProps('error')} label="" />
      <NumberInput {...inputProps('availableChance')} />
    </div>
  )
}

export default SlotGenerator

// const test = {
//   "date_range": { "start": "2020-11-02", "end": "2020-11-06" },
//   "time_range": { "start": "07:00", "end": "19:30" },
//   "previous_start_date": null,
//   "next_start_date": "2020-11-08",
//   "branches": [{
//     "id": 160,
//     "name": "BEKB Huttwil",
//     "holidays": [],
//     "slots": {
//       "2020-11-02": [{
//         "start": "2020-11-02T07:00:00.000+01:00",
//         "end": "2020-11-02T08:00:00.000+01:00",
//         "available": false
//       }, {
//         "start": "2020-11-02T07:30:00.000+01:00",
//         "end": "2020-11-02T08:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T08:00:00.000+01:00",
//         "end": "2020-11-02T09:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T08:30:00.000+01:00",
//         "end": "2020-11-02T09:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T09:00:00.000+01:00",
//         "end": "2020-11-02T10:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T09:30:00.000+01:00",
//         "end": "2020-11-02T10:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T10:00:00.000+01:00",
//         "end": "2020-11-02T11:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T10:30:00.000+01:00",
//         "end": "2020-11-02T11:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T11:00:00.000+01:00",
//         "end": "2020-11-02T12:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T11:30:00.000+01:00",
//         "end": "2020-11-02T12:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T12:00:00.000+01:00",
//         "end": "2020-11-02T13:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T12:30:00.000+01:00",
//         "end": "2020-11-02T13:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T13:00:00.000+01:00",
//         "end": "2020-11-02T14:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T13:30:00.000+01:00",
//         "end": "2020-11-02T14:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T14:00:00.000+01:00",
//         "end": "2020-11-02T15:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T14:30:00.000+01:00",
//         "end": "2020-11-02T15:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T15:00:00.000+01:00",
//         "end": "2020-11-02T16:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T15:30:00.000+01:00",
//         "end": "2020-11-02T16:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T16:00:00.000+01:00",
//         "end": "2020-11-02T17:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T16:30:00.000+01:00",
//         "end": "2020-11-02T17:30:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T17:00:00.000+01:00",
//         "end": "2020-11-02T18:00:00.000+01:00",
//         "available": true
//       }, {
//         "start": "2020-11-02T17:30:00.000+01:00",
//         "end": "2020-11-02T18:30:00.000+01:00",
//         "available": false
//       }, {
//         "start": "2020-11-02T18:00:00.000+01:00",
//         "end": "2020-11-02T19:00:00.000+01:00",
//         "available": false
//       }, {
//         "start": "2020-11-02T18:30:00.000+01:00",
//         "end": "2020-11-02T19:30:00.000+01:00",
//         "available": false
//       }]
//     }
//   }]
// }
